import React from 'react'

import {
    Dropdown,
    DropdownPosition,
    Checkbox,
    UiArrowExpandIcon,
} from '@octane/spark'

import {
    DropdownWrapper,
    NoWrap,
    Item,
    ButtonInner,
    RightAligned,
    StyledButton,
} from './CheckboxDropdown.styled'
import CountBadge from './CountBadge'

// Five 41px rows (16px item padding + 25px Spark checkbox) plus the
// group's 10px top padding; the rest of the list scrolls.
const MAX_MENU_HEIGHT = '215px'

export type DropdownItem = {
    id: string
    label: string
    value: number
    disabled: boolean
    checked: boolean
}

type Props = {
    text: string
    items: DropdownItem[]
    setItems: (items: DropdownItem[]) => void
    isUnique?: boolean
    error?: boolean
    prefilled?: boolean
}

export default function CheckboxDropdown({
    text,
    items,
    setItems,
    isUnique,
    error,
    prefilled,
}: Props): JSX.Element {
    const onChangeHandle = (id: string) => {
        // Don't allow changes when prefilled (read-only mode)
        if (prefilled) {
            return
        }

        const handledItem = items.find((item) => {
            return item.id === id
        })

        if (handledItem) {
            if (!isUnique) {
                handledItem.checked = !handledItem.checked

                setItems([...items])
            } else {
                handledItem.checked = true

                items
                    .filter((item) => item !== handledItem)
                    .forEach((item) => {
                        item.checked = false
                    })

                setItems([...items])
            }
        }
    }

    const selectedCount = items.filter((item) => {
        return item.checked
    }).length

    const Badge =
        selectedCount && !isUnique ? <CountBadge count={selectedCount} /> : null

    const isPlaceholder = !text

    const DropdownButton = (
        <StyledButton error={error} type="button" disabled={prefilled}>
            <ButtonInner>
                <NoWrap isPlaceholder={isPlaceholder}>
                    {text || 'Select options'}
                </NoWrap>
                <RightAligned>{Badge}</RightAligned>
            </ButtonInner>
            <UiArrowExpandIcon
                style={{ marginLeft: 'auto', width: 12, height: 12 }}
            />
        </StyledButton>
    )

    return (
        <DropdownWrapper>
            <Dropdown
                toggle={DropdownButton}
                position={DropdownPosition.LEFT}
                maxMenuHeight={MAX_MENU_HEIGHT}
            >
                <Dropdown.Group>
                    {items.map((item) => (
                        <Item key={item.id}>
                            <Checkbox
                                checked={item.checked}
                                disabled={false}
                                label={item.label}
                                error={false}
                                onChange={() => onChangeHandle(item.id)}
                                value=""
                            />
                        </Item>
                    ))}
                </Dropdown.Group>
            </Dropdown>
        </DropdownWrapper>
    )
}

CheckboxDropdown.defaultProps = {
    isUnique: false,
}
